import { render, staticRenderFns } from "./TheMainHeader.vue?vue&type=template&id=03991242&scoped=true"
import script from "./TheMainHeader.vue?vue&type=script&lang=ts"
export * from "./TheMainHeader.vue?vue&type=script&lang=ts"
import style0 from "./TheMainHeader.vue?vue&type=style&index=0&id=03991242&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03991242",
  null
  
)

export default component.exports